import { put, call, takeLatest, select } from 'redux-saga/effects';

import { checkColleagueEmails } from 'services/advocate';
import { AsyncAction } from 'types/Action';
import {
  CheckColleagueEmailsMeta,
  CheckColleagueEmailsPayload,
} from 'types/store/CheckColleagueEmails';
import { Store } from 'types/store/Store';

import { checkColleagueEmailsActions } from '../actions';

function* checkColleagueEmailsRequest(
  action: AsyncAction<CheckColleagueEmailsMeta, CheckColleagueEmailsPayload>
) {
  const state: Store = yield select();
  if (state.auth.token) {
    try {
      const { data } = yield call(
        checkColleagueEmails,
        action.meta,
        state.auth.token
      );
      yield put(checkColleagueEmailsActions.success(data));
      // yield put(getPagesbyCompanyIdActions.success(data));
    } catch (e: any) {
      //
    }
  } else {
    //
  }
}

function* checkColleagueEmailsWatcher(): any {
  yield takeLatest(
    checkColleagueEmailsActions.REQUEST,
    checkColleagueEmailsRequest
  );
}

export default checkColleagueEmailsWatcher;
